// Historia 160 (RN24-RN26) — qué pestañas ("Bloques") tiene el detalle del job y cuál queda activa.
//
// Piezas puras, sin React: la visibilidad sale SOLO de los resúmenes de D1 y del permiso de ver
// documentación (que decide `hasAnyDocumentViewPermission` de #148, no esta pieza).

export const JOB_DETAIL_TAB = {
  GENERAL: 'GENERAL',
  DOCUMENTS: 'DOCUMENTS',
  MATERIALS: 'MATERIALS',
  INSPECTIONS: 'INSPECTIONS',
  INCIDENCES: 'INCIDENCES',
  PARTS: 'PARTS'
}

/** Orden fijo de la lista lateral (RN24). */
export const JOB_DETAIL_TAB_ORDER = [
  JOB_DETAIL_TAB.GENERAL,
  JOB_DETAIL_TAB.DOCUMENTS,
  JOB_DETAIL_TAB.MATERIALS,
  JOB_DETAIL_TAB.INSPECTIONS,
  JOB_DETAIL_TAB.INCIDENCES,
  JOB_DETAIL_TAB.PARTS
]

/** Pestañas cuyo contenido es un bloque propio de Sun (D2-D5), cargado y refrescado mientras se ve. */
export const BLOCK_TABS = [
  JOB_DETAIL_TAB.MATERIALS,
  JOB_DETAIL_TAB.INSPECTIONS,
  JOB_DETAIL_TAB.INCIDENCES,
  JOB_DETAIL_TAB.PARTS
]

export const isBlockTab = (tab) => BLOCK_TABS.includes(tab)

/**
 * @param {Object} summary `summary` de D1
 * @param {boolean} canViewDocuments resultado de `hasAnyDocumentViewPermission` (D16)
 * @returns {string[]} las pestañas visibles, en el orden fijo de RN24
 */
export const visibleTabs = (summary = {}, canViewDocuments = false) => {
  const visibility = {
    [JOB_DETAIL_TAB.GENERAL]: true,
    [JOB_DETAIL_TAB.DOCUMENTS]: canViewDocuments === true,
    [JOB_DETAIL_TAB.MATERIALS]: (summary.materials?.total || 0) > 0,
    [JOB_DETAIL_TAB.INSPECTIONS]: (summary.inspections?.features || 0) > 0,
    [JOB_DETAIL_TAB.INCIDENCES]: (summary.incidences?.open || 0) > 0,
    [JOB_DETAIL_TAB.PARTS]: true
  }
  return JOB_DETAIL_TAB_ORDER.filter((tab) => visibility[tab])
}

/**
 * RN26: se conserva la pestaña activa mientras siga visible; si no, General.
 * @param {string} current
 * @param {string[]} visible
 */
export const nextActiveTab = (current, visible) =>
  visible.includes(current) ? current : JOB_DETAIL_TAB.GENERAL
